export const FEATURE_NAME = 'MarketStudyChest';
